"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRewardConfigsResponseAllOfToJSON = exports.GetRewardConfigsResponseAllOfFromJSONTyped = exports.GetRewardConfigsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetRewardConfigsResponseAllOfFromJSON(json) {
    return GetRewardConfigsResponseAllOfFromJSONTyped(json, false);
}
exports.GetRewardConfigsResponseAllOfFromJSON = GetRewardConfigsResponseAllOfFromJSON;
function GetRewardConfigsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rewards': (json['rewards'].map(_1.RewardConfigResponseFromJSON)),
    };
}
exports.GetRewardConfigsResponseAllOfFromJSONTyped = GetRewardConfigsResponseAllOfFromJSONTyped;
function GetRewardConfigsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rewards': (value.rewards.map(_1.RewardConfigResponseToJSON)),
    };
}
exports.GetRewardConfigsResponseAllOfToJSON = GetRewardConfigsResponseAllOfToJSON;
